


const Table12 = ({children}) => {

    return (
        <>
            <div className='column is-12 p-3'>
                <div className='welcome__master p-3' style={{width: '100%', height: '100%'}}>

                    <h4 className='pinar has-text-centered has-text-weight-bold my-3'>
                        لیست بسته ها


                    </h4>


                    <table className='table width100'>
                        <thead className='clrtwo'>
                        <tr className=''>
                            <th className='has-text-centered has-text-white'>کد رهگیری</th>
                            <th className='has-text-centered has-text-white'>شهر</th>
                            <th className='has-text-centered has-text-white'>نام فرستنده</th>
                            <th className='has-text-centered has-text-white'>تلفن فرستنده</th>
                            <th className='has-text-centered has-text-white'>نام گیرنده</th>
                            <th className='has-text-centered has-text-white'>تلفن گیرنده</th>
                            <th className='has-text-centered has-text-white'>آدرس</th>
                            <th className='has-text-centered has-text-white'>وضعیت</th>


                        </tr>

                        </thead>

                        <tbody>

                        {
                            children
                        }



                        </tbody>
                    </table>


                </div>
            </div>


        </>
    )
}
export default Table12;